import React, { useState } from "react";

function Footer({ onShowPrivacy, contactEmail }) {
  const [showContact, setShowContact] = useState(false);

  return (
    <>
      <footer className="main-footer">
        <div className="footer-content">
          <div className="footer-left">
            <span className="footer-logo">&gt;</span>
            <p className="footer-copyright">
              © 2026 <span className="footer-brand">Accenture</span>. All rights reserved.
            </p>
          </div>
          <div className="footer-right">
            <button
              className="footer-link footer-contact-btn"
              onClick={onShowPrivacy}
            >
              Terms & Privacy
            </button>
            <span className="footer-divider">|</span>
            <button
              className="footer-link footer-contact-btn"
              onClick={() => setShowContact(true)}
            >
              Contact
            </button>
          </div>
        </div>
      </footer>

      {showContact && (
        <div className="contact-overlay" onClick={() => setShowContact(false)}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
            <button className="contact-close" onClick={() => setShowContact(false)}>✕</button>
            <div className="contact-header">
              <span className="contact-icon">✉</span>
              <h3>Contact Us</h3>
            </div>
            <p className="contact-description">
              For access requests, feature requests, or data inquiries — reach out to us via email. We're here to help!
            </p>
            <div className="contact-body">
              <div className="contact-item">
                <span className="contact-label">Email</span>
                {contactEmail && (
                  <a href={`mailto:${contactEmail}`} className="contact-value contact-email">
                    {contactEmail}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;